import { CmsComponentTypeEnum } from '@models/enums';
import { BaseComponentConfig } from '@interfaces/config';
import {  TextMediaBox } from '@interfaces/config';
export namespace Accordion {
  export const TypeEnum = CmsComponentTypeEnum.ACCORDION;

  export interface AccordionItemConfig {
    headline: string;
    subheadline: string;
    description: string;
    active?: boolean;
    media?:TextMediaBox.MediaImageConfig;
  }

  export interface ComponentConfig extends BaseComponentConfig {
    headline: string;
    description: string;
    items: AccordionItemConfig[];
  }
}
